/* GLANZ — das Kippen der Produktkacheln unter dem Zeiger.
 *
 * Warum überhaupt Skript: Eine Kachel, die sich zum Zeiger hin neigt, geht
 * mit CSS allein nicht — CSS kennt die Zeigerposition nicht. Es sind rund
 * 40 Zeilen, und sie tun nichts, solange niemand mit einer Maus über eine
 * Kachel fährt.
 *
 * Was hier bewusst NICHT passiert:
 *   - kein Beobachter über alle Kacheln (auf einer Kollektionsseite wären
 *     das schnell 50 Stück, jede mit eigenem Zustand)
 *   - keine Rechnung pro Mausbewegung; es wird auf das nächste Bild gelegt
 *   - nichts auf Touchgeräten, nichts bei „Bewegung reduzieren"
 *
 * Gearbeitet wird mit einem einzigen Zuhörer am Dokument. Welche Kachel
 * gemeint ist, sagt `closest()` — das ist billiger als 50 Zuhörer.
 */
(function () {
  "use strict";

  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var NEIGUNG = 5;          // Grad. Mehr wirkt nach Spielerei, weniger sieht man nicht.
  var aktuell = null;
  var offen = false;
  var zx = 0, zy = 0;

  function auftragen() {
    offen = false;
    if (!aktuell) return;
    var r = aktuell.getBoundingClientRect();
    if (!r.width || !r.height) return;
    /* -0.5 .. +0.5 vom Mittelpunkt aus. */
    var ax = (zx - r.left) / r.width  - 0.5;
    var ay = (zy - r.top)  / r.height - 0.5;
    /* Y-Drehung folgt der waagerechten Bewegung, X-Drehung der senkrechten —
       und letztere umgekehrt, sonst kippt die Kachel vom Zeiger weg statt
       zu ihm hin. */
    aktuell.style.setProperty("--ky", ( ax * NEIGUNG * 2).toFixed(2) + "deg");
    aktuell.style.setProperty("--kx", (-ay * NEIGUNG * 2).toFixed(2) + "deg");
  }

  function loslassen(el) {
    if (!el) return;
    el.classList.remove("hoa-kipp--aktiv");
    el.style.setProperty("--kx", "0deg");
    el.style.setProperty("--ky", "0deg");
  }

  document.addEventListener("pointermove", function (e) {
    var kachel = e.target.closest && e.target.closest(".card-wrapper");
    if (kachel !== aktuell) {
      loslassen(aktuell);
      aktuell = kachel;
      if (aktuell) {
        aktuell.classList.add("hoa-kipp", "hoa-kipp--aktiv");
      }
    }
    if (!aktuell) return;
    zx = e.clientX; zy = e.clientY;
    if (!offen) { offen = true; requestAnimationFrame(auftragen); }
  }, { passive: true });

  /* Verlässt der Zeiger das Fenster, bleibt sonst die zuletzt berührte
     Kachel schief stehen. */
  document.addEventListener("pointerleave", function () {
    loslassen(aktuell); aktuell = null;
  }, { passive: true });

  /* Beim Scrollen ebenfalls loslassen: die Kachel wandert unter dem
     stehenden Zeiger weg, die Neigung passt dann nicht mehr zur Lage. */
  window.addEventListener("scroll", function () {
    if (aktuell) { loslassen(aktuell); aktuell = null; }
  }, { passive: true });
})();
